<div class="join-nuagedx-network-dialog">
  <button
    class="close-btn"
    mat-flat-button
    mat-dialog-close
    color="warn">
    X
  </button>

  <h2 mat-dialog-title>Join NuageDx Network</h2>

  <div mat-dialog-content class="dialog-content">
    <div class="benefits-section">
      <h3>Benefits of Joining NuageDx Network</h3>
      
      <div class="benefit-item">
        <mat-icon class="benefit-icon">cloud</mat-icon>
        <div class="benefit-text">
          <h4>Seamless Cloud Integration</h4>
          <p>Connect with healthcare facilities across the network for instant medical record sharing and collaboration.</p>
        </div>
      </div>

      <div class="benefit-item">
        <mat-icon class="benefit-icon">security</mat-icon>
        <div class="benefit-text">
          <h4>Enhanced Security & Compliance</h4>
          <p>HIPAA-compliant infrastructure ensuring your patient data is protected with enterprise-grade security measures.</p>
        </div>
      </div>

      <div class="benefit-item">
        <mat-icon class="benefit-icon">speed</mat-icon>
        <div class="benefit-text">
          <h4>Faster Patient Care</h4>
          <p>Reduce administrative delays and improve patient outcomes with real-time access to medical records.</p>
        </div>
      </div>

      <div class="benefit-item">
        <mat-icon class="benefit-icon">group</mat-icon>
        <div class="benefit-text">
          <h4>Network Collaboration</h4>
          <p>Join a growing network of healthcare providers, facilitating better coordination and continuity of care.</p>
        </div>
      </div>

      <div class="benefit-item">
        <mat-icon class="benefit-icon">trending_up</mat-icon>
        <div class="benefit-text">
          <h4>Scalable Solutions</h4>
          <p>Grow your practice with flexible plans that adapt to your facility's needs and patient volume.</p>
        </div>
      </div>

      <div class="benefit-item">
        <mat-icon class="benefit-icon">support_agent</mat-icon>
        <div class="benefit-text">
          <h4>Dedicated Support</h4>
          <p>Access to our expert support team to help you maximize the benefits of the NuageDx Network.</p>
        </div>
      </div>
    </div>

    <div class="cta-section">
      <p class="cta-text">Ready to join? Contact our team to learn more about network membership and get started today.</p>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button color="primary" (click)="onClose()">Close</button>
    <button mat-flat-button color="accent" (click)="onClose()">Contact Us</button>
  </div>
</div>
